"use client";

import Fuse from "fuse.js";
import { useMemo } from "react";

import { NoArtistInstrumentModelMixedModel } from "@/components/selectArtistModal/NoArtistInstrumentModelMixedModel";
import { VoiceGrid } from "@/components/selectArtistModal/VoiceGrid";
import { instruments } from "@/constants/instruments";
import { nameFuseConfig } from "@/lib/fuse/nameFuseConfig";
import { useNamedSelectArtistFilters } from "@/lib/zustand/useSelectArtistFilters";
import { ArtistInstumentSaved, UserNoDates } from "@/types/types";

export function InstrumentsTab({
  handleClickArtist,
  closeModal,
  user,
  savedArtistsInstrumentsIds,
  namespace,
}: {
  handleClickArtist: (artistId: string) => void;
  closeModal: () => void;
  user: UserNoDates | null;
  savedArtistsInstrumentsIds: ArtistInstumentSaved["artistInstrumentId"][];
  namespace: string;
}) {
  const useSelectArtistFilters = useNamedSelectArtistFilters((state) =>
    state.getNamedStore(namespace)
  );
  const searchString = useSelectArtistFilters((state) => state.searchString);

  const fuse = useMemo(
    () => new Fuse(instruments, nameFuseConfig),
    [instruments]
  );

  // Filter instruments based on search
  const filteredInstruments =
    searchString !== "" ?
      fuse.search(searchString).map((result) => result.item)
    : instruments;

  const noInstruments = filteredInstruments.length === 0;

  return noInstruments ?
      <NoArtistInstrumentModelMixedModel text="No instruments found. Try changing your search term." />
    : <VoiceGrid
        voices={filteredInstruments}
        handleClickArtist={(artistId) => {
          handleClickArtist(artistId);
          closeModal();
        }}
        user={user}
        savedArtistsInstrumentsIds={savedArtistsInstrumentsIds}
      />;
}
